export const GET_NETWORK_ERROR = "GET_NETWORK_ERROR";
export const SET_NETWORK_ERROR = "SET_NETWORK_ERROR";
